'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash.assign');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isfunction');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.difference');

var _lodash6 = _interopRequireDefault(_lodash5);

var _loglevel = require('loglevel');

var _loglevel2 = _interopRequireDefault(_loglevel);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _Authenticator = require('./Authenticator');

var _Authenticator2 = _interopRequireDefault(_Authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// log.enableAll();
// log.setLevel('warn');

var chunk = function chunk(arr, size) {
    return arr.length ? [arr.slice(0, size)].concat(_toConsumableArray(chunk(arr.slice(size), size))) : [];
};

/**
 * Adobe Pass implementation of the abstract Authenticator class.
 * @class AdobePassAuthenticator
 * @augments Authenticator
 */
function AdobePassAuthenticator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        elementId = _ref.elementId,
        _ref$redirectUrl = _ref.redirectUrl,
        redirectUrl = _ref$redirectUrl === undefined ? '' : _ref$redirectUrl,
        _ref$environment = _ref.environment,
        environment = _ref$environment === undefined ? AdobePassAuthenticator.Environment.PRODUCTION : _ref$environment,
        _ref$refreshless = _ref.refreshless,
        refreshless = _ref$refreshless === undefined ? false : _ref$refreshless,
        _ref$displayProviderD = _ref.displayProviderDialogImpl,
        displayProviderDialogImpl = _ref$displayProviderD === undefined ? function () {
        return new Promise();
    } : _ref$displayProviderD,
        _ref$errorEventHandle = _ref.errorEventHandlerName,
        errorEventHandlerName = _ref$errorEventHandle === undefined ? 'AEErrorHandler' : _ref$errorEventHandle;

    if (!(this instanceof AdobePassAuthenticator)) {
        return new AdobePassAuthenticator({
            elementId: elementId,
            redirectUrl: redirectUrl,
            environment: environment,
            refreshless: refreshless,
            displayProviderDialogImpl: displayProviderDialogImpl
        });
    }

    (0, _lodash2.default)(this, _events2.default.prototype, _Authenticator2.default.prototype);

    var REQUESTOR = 'ESPN';

    var JS_URLS = {};
    JS_URLS[AdobePassAuthenticator.Environment.PRODUCTION] = 'https://entitlement.auth.adobe.com/entitlement/v4/AccessEnabler.js';
    JS_URLS[AdobePassAuthenticator.Environment.STAGING] = 'https://entitlement.auth-staging.adobe.com/entitlement/v4/AccessEnabler.js';
    var JS_ELEMENT_ID = 'ae_js';

    var SOFTWARE_STATEMENTS = {};
    SOFTWARE_STATEMENTS[AdobePassAuthenticator.Environment.PRODUCTION] = 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIyZGJmZWM4My03OWE1LTQyNzEtYTVmZC04NTZjYTMxMjRjNjMiLCJuYmYiOjE1NDAyMTI3NjEsImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNTQwMjEyNzYxfQ.yaK3r4AI2uLVvsyN1GLzqzgzRlxMPtasSaiYYBV0wIstqih5tvjTmeoLmi8Xy9Kp_U7Md-bOffwiyK3srHkpUkhhwXLH2x6RPjmS1tPmhaG7-3LBcHTf2ySPvXhVf7cN4ngldawK4tdtLtsw6rF_JoZE2yaC6XbS2F51nXSFEDDnOQWIHEQRG3aYAj-38P2CLGf7g-Yfhbp5cKXeksHHQ90u3eOO4WH0EAjc9oO47h33U8KMEXxJbvjV5J8Va2G2fQSgLDZ013NBI3kQnE313qgqQh2feQILkyCENpB7g-TVBreAjOaH1fU471htSoGGYepcAXv-UDtpgitDiLy7CQ'; // eslint-disable-line
    SOFTWARE_STATEMENTS[AdobePassAuthenticator.Environment.STAGING] = 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhMmRjNjgyMC1kZGNkLTQ4NGEtOTdlNS0xZjJiZmQzOGI4YzgiLCJuYmYiOjE1NDAyMjIwNTksImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNTQwMjIyMDU5fQ.YgX4ecGCgLCaZS7uwRQYZ8UR5EwT7GIl-glFbwU122bO1JYZSmbIX8YJSfmYth_scyeg-15BYWNftV9lOcmCe8VwIsQMJMIZKaF8qSIj5OfuTOBpNZNBpDAp5dC3zG7Zp1xLe3z-T0Y18-0BGj2yhGcJxBz4gtLXQ30Bw0LEIJ89nXCQaXFTq9N6zhDzMfkFJNnSNEvEmvcQqB4bFPIqn2is8427oQDU4D0XYvvTtx9eb5hmzKc9MbBG-8KRBA62BqdHomA5UA4kBYJKpe-8B2hO07Adi2bZoo5wP_VLNAnAxANWNXaGQYHMDjHDrHbbvuKHBudHgKxAuKpIdC7UrA'; // eslint-disable-line
    var _softwareStatement = SOFTWARE_STATEMENTS[environment];

    var _accessEnablerJsUrl = JS_URLS[environment];
    var _redirectUrl = redirectUrl;
    var _accessEnabler = null;
    var _resolveInitialize = null;
    var _resolveAuthentication = null;
    var _resolveDeauthentication = null;
    var _resolveAuthorization = null;
    var _resolvePreauthorizes = [];
    var _resolveAuthenticationInfo = null;
    var _resolveMetadataStatus = {};
    var _resolveSelectProvider = null;
    var _errorEventCallback = null;

    var _isAuthenticated = false;

    function entitlementLoaded() {
        _accessEnabler.bind('errorEvent', errorEventHandlerName);

        var requestorConfigInfo = refreshless ? {
            callSetConfig: true,
            backgroundLogin: false,
            backgroundLogout: true
        } : null;
        _accessEnabler.setRequestor(REQUESTOR, null, requestorConfigInfo);
        if (_resolveInitialize) {
            _resolveInitialize(true);
        }
    }

    function setAuthenticationStatus(isAuthenticated, errorCode) {
        _loglevel2.default.debug('AdobePassAuthenticator.setAuthenticationStatus', isAuthenticated, errorCode);
        _isAuthenticated = !!isAuthenticated;

        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }

        if (_resolveSelectProvider) {
            _resolveSelectProvider(_isAuthenticated);
            _resolveSelectProvider = null;
        }

        if (_resolveDeauthentication) {
            _resolveDeauthentication(_isAuthenticated);
            _resolveDeauthentication = null;
        }
    }

    function setMetadataStatus(key, encrypted, data) {
        _loglevel2.default.debug('AdobePassAuthenticator.setMetadataStatus', key, data);
        if (_resolveMetadataStatus[key]) {
            _resolveMetadataStatus[key](data);
        }
        _resolveMetadataStatus[key] = null;
    }

    function _displayProviderDialog(providers) {
        _loglevel2.default.debug('AdobePassAuthenticator.displayProviderDialog', providers);
        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }
        displayProviderDialogImpl(providers);
        /*
        .then(function(provider) {
         _accessEnabler.setSelectedProvider(provider);
         });
         */
    }

    function setToken(resourceId, token) {
        _loglevel2.default.debug('Requested resource: ' + resourceId + ' tokenResult: ' + token);
        if (_resolveAuthorization) {
            _resolveAuthorization({ resourceId: resourceId, token: token });
        }
    }

    function tokenRequestFailed(resourceId, errorCode, errorDetails) {
        if (errorCode != null || errorDetails != null) {
            _loglevel2.default.error('Failure to authorize: ' + errorDetails);
            if (_resolveAuthorization) {
                _resolveAuthorization({ errorCode: errorCode, errorDetails: errorDetails });
            }
        }
    }

    function setConfig() /* configXml */{
        // log.debug('setConfig', configXml);
    }

    function sendTrackingData(trackingEventType, trackingData) {
        if (trackingEventType === 'authenticationDetection') {
            var data = {
                success: trackingData[0],
                mvpd: trackingData[1],
                guid: trackingData[2],
                isTokenCached: trackingData[3],
                deviceType: trackingData[4],
                clientType: trackingData[5],
                os: trackingData[6]
            };

            _loglevel2.default.debug('AdobePassAuthenticator.sendTrackingData', trackingEventType, data);
        }
    }

    function preauthorizedResources(authorizedResources) {
        _loglevel2.default.debug('AdobePassAuthenticator.preauthorizedResources', authorizedResources);

        var completion = _resolvePreauthorizes.shift();
        if (completion) completion(authorizedResources);
    }

    function embedJs() {
        var scriptTag = document.createElement('script');
        scriptTag.id = JS_ELEMENT_ID;
        scriptTag.type = 'text/javascript';
        scriptTag.async = true;
        scriptTag.src = _accessEnablerJsUrl;
        scriptTag.addEventListener('load', function () {
            _accessEnabler = new window.Adobe.AccessEnabler(_softwareStatement);
        });
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }

    function selectedProvider(result) {
        var mvpd = result.MVPD,
            aeState = result.AE_State;

        if (_resolveAuthenticationInfo) _resolveAuthenticationInfo({ mvpd: mvpd, aeState: aeState });
    }

    function AEErrorHandler(errorData) {
        if (typeof _errorEventCallback === 'function') {
            _errorEventCallback(errorData);
        }
    }

    function bindCallbacks() {
        global.entitlementLoaded = entitlementLoaded;
        global.setAuthenticationStatus = setAuthenticationStatus;
        global.setMetadataStatus = setMetadataStatus;
        global.displayProviderDialog = _displayProviderDialog;
        global.setConfig = setConfig;
        global.sendTrackingData = sendTrackingData;
        global.preauthorizedResources = preauthorizedResources;
        global.selectedProvider = selectedProvider;
        global.setToken = setToken;
        global.tokenRequestFailed = tokenRequestFailed;
        global[errorEventHandlerName] = AEErrorHandler;
    }

    return (0, _lodash2.default)(this, {
        /**
         * Initializes the Adobe Pass client
         * @function initialize
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<null>}
         */
        initialize: function initialize(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.initialize');

            return new Promise(function (resolve) {
                _resolveInitialize = function _resolveInitialize(isInitialized) {
                    resolve(isInitialized);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isInitialized);
                    }
                };
                bindCallbacks();
                embedJs();
            });
        },


        /**
         * @function isAuthenticated
         * @override
         * @memberof AdobePassAuthenticator#
         * @returns {Boolean}
         */
        isAuthenticated: function isAuthenticated() {
            return _isAuthenticated;
        },


        /**
         * @function setRedirectUrl
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {String} a redirect url
         * @returns boolean
         */
        setRedirectUrl: function setRedirectUrl(url) {
            if (typeof url === 'string') {
                _redirectUrl = url;
                return true;
            }
            return false;
        },


        /**
         * @function checkAuthentication
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        checkAuthentication: function checkAuthentication(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.checkAuthentication');

            return new Promise(function (resolve) {
                _resolveAuthentication = function _resolveAuthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.checkAuthentication();
            });
        },


        /**
         * @function authenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {String} identity
         * @param {Callback} callback
         * @param {String} optional redirect url
         * @returns {Promise.<Boolean>}
         */
        authenticate: function authenticate(identity, callback) {
            var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _redirectUrl;

            _loglevel2.default.debug('AdobePassClient.authenticate ' + identity);

            return new Promise(function (resolve) {
                _resolveAuthentication = function _resolveAuthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.getAuthentication(url);
            });
        },


        /**
         * @function deauthenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        deauthenticate: function deauthenticate(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.deauthenticate');

            return new Promise(function (resolve) {
                _resolveDeauthentication = function _resolveDeauthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.logout();
            });
        },


        /**
         * @function getAuthenticationInfo
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        getAuthenticationInfo: function getAuthenticationInfo(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.getAuthenticationInfo');

            var getAuthenticationInfoPromise = new Promise(function (resolve) {
                _resolveAuthenticationInfo = resolve;
            });
            _accessEnabler.getSelectedProvider();

            if ((0, _lodash4.default)(callback)) {
                callback(null, true);
            }

            return getAuthenticationInfoPromise;
        },


        /**
         * @function getMetadata
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        getMetadata: function getMetadata(key) {
            _loglevel2.default.debug('AdobePassAuthenticator.getMetadata');
            var getMetadataPromise = new Promise(function (resolve) {
                if (key) {
                    _resolveMetadataStatus[key] = resolve;
                } else {
                    resolve(null);
                }
            });
            if (key) {
                _accessEnabler.getMetadata(key);
            }
            return getMetadataPromise;
        },


        /**
         * @function authorize
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        authorize: function authorize(resource, callback) {
            _loglevel2.default.debug('AdobePassClient.authorize ' + resource);

            return new Promise(function (resolve) {
                _resolveAuthorization = function _resolveAuthorization(authzResponse) {
                    resolve(authzResponse);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, authzResponse);
                    }
                };
                _accessEnabler.getAuthorization(resource);
            });
        },


        /**
         * @function checkPreauthorizedResources
         * @memberof AdobePassAuthenticator#
         * @param {}
         * @returns {Promise.<Array>}
         */
        checkPreauthorizedResources: function checkPreauthorizedResources() {
            var _this = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var hasCallback = (0, _lodash4.default)(args[args.length - 1]);
            var resources = hasCallback ? args.slice(0, args.length - 1) : args;
            var callback = hasCallback ? args[args.length - 1] : null;

            if (_isAuthenticated !== true) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, []);
                }
                return Promise.resolve([]);
            }

            var completions = [];

            var groupedResources = chunk(resources, 5);

            var promises = groupedResources.map(function (resourceGroup) {
                return new Promise(function (resolve) {
                    var completion = function completion(preauthzResources) {
                        resolve(preauthzResources);
                    };

                    completions.push(completion);

                    _accessEnabler.checkPreauthorizedResources(resourceGroup);
                }).catch(function () {
                    return [];
                });
            });

            _resolvePreauthorizes = completions;

            return Promise.all(promises).then(function (results) {
                var result = results.reduce(function (acc, val) {
                    return acc.concat(val);
                }, []);

                result.forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.PREAUTHORIZED, resource);
                });

                (0, _lodash6.default)(resources, result).forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.NOT_PREAUTHORIZED, resource);
                });

                if ((0, _lodash4.default)(callback)) {
                    callback(null, result);
                }
                return result;
            });
        },
        selectProvider: function selectProvider(provider) {
            _accessEnabler.setSelectedProvider(provider.ID);
            return new Promise(function (resolve) {
                if (refreshless) {
                    _resolveSelectProvider = resolve;
                }
            });
        },
        onErrorEvent: function onErrorEvent(callback) {
            _errorEventCallback = callback;
        }
    });
}

AdobePassAuthenticator.Environment = {
    PRODUCTION: 'production',
    STAGING: 'staging'
};

AdobePassAuthenticator.EventType = {
    PREAUTHORIZED: 'preauthorized',
    NOT_PREAUTHORIZED: 'not_preauthorized'
};

AdobePassAuthenticator.AccessEnablerType = {
    JAVASCRIPT: 'js'
};

exports.default = AdobePassAuthenticator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/watch-authenticators/build/AdobePassAuthenticator.js
// module id = 663
// module chunks = 1